import { useT } from '../i18n';
import { STATE_COLOR } from './Nav.jsx';
import { go } from '../lib/nav';

// Stylised Switzerland (same drawing as the approved Main mockup), 640 × 400.
const OUTLINE = 'M28 318 L52 282 L96 262 L120 228 L160 200 L188 160 L214 118 L238 86 L262 70 L300 74 L332 56 L368 40 L392 54 L436 52 L470 64 L520 84 L560 104 L596 136 L604 170 L580 196 L560 220 L586 248 L566 272 L522 264 L486 252 L460 266 L444 300 L432 334 L412 366 L394 350 L384 318 L368 290 L338 288 L300 306 L262 330 L226 340 L186 336 L150 318 L118 324 L90 334 L60 330 Z';
const LAKES = [[86, 296, 44, 11, -18], [378, 118, 22, 5, -40], [496, 70, 30, 8, -20], [330, 172, 22, 7, 0]];
const MAPC = { crit: '#C8261B', alarm: '#E3721C', warn: '#C98A12', delayed: '#8796A0', ok: '#2E8B57' };

export default function SwissMap({ cities }) {
  const t = useT();
  return (
    <svg viewBox="0 0 640 400" width="100%" role="img" aria-label={t('map.aria')} style="display:block;max-height:440px">
      <defs>
        <radialGradient id="landg" cx="50%" cy="40%" r="70%"><stop offset="0" stop-color="var(--map-land)" /><stop offset="1" stop-color="var(--map-land)" stop-opacity=".75" /></radialGradient>
      </defs>
      <path d={OUTLINE} fill="url(#landg)" stroke="var(--map-edge)" stroke-width="2" stroke-linejoin="round" />
      {LAKES.map(([x, y, rx, ry, r], i) => <ellipse key={i} cx={x} cy={y} rx={rx} ry={ry} transform={`rotate(${r} ${x} ${y})`} fill="var(--map-lake)" />)}
      {cities.map((c, i) => {
        const r = c.count <= 2 ? 7 : Math.max(10, Math.min(19, 6 + Math.sqrt(c.count) * 1.6));
        const col = MAPC[c.worst] || MAPC.ok; const hot = c.worst === 'crit' || c.worst === 'alarm';
        return (
          <g key={c.id} style={`cursor:pointer;animation:popin .5s ${0.25 + i * 0.05}s both cubic-bezier(.2,1.4,.4,1);transform-origin:${c.x}px ${c.y}px`} onClick={() => go('/loc/' + c.id)} role="link" aria-label={`${c.name}: ${c.count}`}>
            {hot && <circle cx={c.x} cy={c.y} r={r} fill="none" stroke={col} stroke-width="2"><animate attributeName="r" values={`${r};${r + 16};${r}`} dur="2.2s" repeatCount="indefinite" /><animate attributeName="stroke-opacity" values=".8;0;.8" dur="2.2s" repeatCount="indefinite" /></circle>}
            <circle cx={c.x} cy={c.y} r={r} fill={col} fill-opacity=".92" stroke="#fff" stroke-width="2" />
            {c.count > 2 && <text x={c.x} y={c.y + 4.5} text-anchor="middle" fill="#fff" font-weight="700" font-size="13" font-family="var(--f-body)">{c.count}</text>}
            <text x={c.x + (c.lx || 0)} y={c.y + (c.ly ?? (r + 15))} text-anchor={c.anchor || 'middle'} fill="var(--fg)" font-size="13" font-family="var(--f-body)">{c.name}</text>
          </g>
        );
      })}
      <style>{'@keyframes popin{from{opacity:0;transform:scale(.2)}}'}</style>
    </svg>
  );
}
